import React from 'react';
import { Tag, Icon } from 'antd';
import utils from '../../utils';
import fetch from '../fetch';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection = () => {
    return DataGrid.selections;
}

const columns = utils.columns([
    { key: '$index', label: '序号', width: 75 },
    {
        key: 'orgName',
        label: '部门名称',
        width: 175
    },
    {
        key: 'createTime',
        label: '生成时间',
        width: 125
    },
    {
        key: 'termName',
        label: '学期',
        width: 125
    },
    {
        key: 'status',
        label: '状态',
        width: 100,
        render: (val) => {
            if (val === 1) {
                return <Tag color='#108ee9'>生成中</Tag>
            } else if (val === 2) {
                return <Tag color='#87d068'>已完成</Tag>
            } else {
                return <Tag color='#f50'>生成失败</Tag>
            }
        }
    },
    {
        key: '', label: '报告', width: 50, render: (d, row) => {
            if (row.status == 2) {
                return <div> <a
                    href={`${fetch.base}jxcpReportTerm/export?id=${row.id}`}
                    style={{ display: 'inline-block' }}
                    target="_blank" onClick={() => {
                    }}>
                    <Icon type="download"></Icon>
                    下载报告</a> | <a
                        href={`${fetch.base}jxcpReportTerm/preview/${row.id}`}
                        style={{ display: 'inline-block' }}
                        target="_blank" onClick={() => {
                        }}>
                        <Icon type="eye"></Icon>
                        预览报告</a>
                    {
                        row.newReportFileId ?
                            <span>
                                |<a
                                    href={`${fetch.base}jxcpReportTerm/download/${row.id}`}
                                    style={{ display: 'inline-block' }}
                                    target="_blank" onClick={() => {
                                    }}>
                                    <Icon type="download"></Icon>
                                    下载更正后的报告</a>
                            </span> : ''
                    }

                </div>
            } if (row.status == 3) {
                return <div>生成过程中出现错误，请联系管理员！</div>
            } else {
                return <div>等待生成后再下载！</div>
            }
        },
        width: 300
    },
])

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] !== '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('jxcpReportTerm/query?' + params.join('&'), keywords)
        .then((response) => {
            if (response.code === 200) {
                return response.payload.data;
            }
        }).then(data => (
            Object.assign({
                result: data.dataList || [],
                selects: (data.dataList || []).map(d => ({
                    value: d.id,
                    checked: false,
                })),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: (data || []).length ? '' : '暂无数据...'
            }))
        )
}

const remove = (ids) => {
    return fetch.post(`/jxcpReportTerm/delete`, ids)
}

const updateReport = (data) => {
    return fetch.post(`/jxcpReportTerm/updateReport`, data)
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    columns,
    querySearch,
    remove,
    updateReport
}